import { render } from "./Delegator.vue?vue&type=template&id=72268279&scoped=true"
import script from "./Delegator.vue?vue&type=script&setup=true&lang=js"
export * from "./Delegator.vue?vue&type=script&setup=true&lang=js"

import "./Delegator.vue?vue&type=style&index=0&id=72268279&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72268279"],['__file',"src/views/Delegator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72268279"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72268279', __exports__)) {
    api.reload('72268279', __exports__)
  }
  
  module.hot.accept("./Delegator.vue?vue&type=template&id=72268279&scoped=true", () => {
    api.rerender('72268279', render)
  })

}


export default __exports__